import { ApiValidationError } from './api-validation.error';
import { Response } from '@schema';

export class ApiMutationError extends ApiValidationError {
  override cause: undefined;
  protected override record!: { returnResponse: Response };

  override buildInstance() {
    const { fieldName, errorType } = this.record.returnResponse;
    this.scope = fieldName!;
    this.key = errorType!;
    return this;
  }
}
